document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".panel-title").forEach(panelTitle => {
    if (panelTitle.innerHTML === "")
      panelTitle.classList.add("hidden")
  })

  document.querySelectorAll(".radio.input.required input[type=radio]").forEach(input => {
    Object.assign(input, {required: true})
  })

  document.querySelectorAll("tr.separator-row").forEach(row => {
    row.querySelector("th").remove()
    row.querySelector("td").innerHTML = ""
  })

  document.querySelectorAll("button.cancel-button").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (e.target.dataset.path !== undefined) {
        window.location.assign(
            `${window.location.protocol}//${window.location.host}${e.target.dataset.path}`
        )
      }
    })
  })

  document.querySelectorAll("form").forEach(form => {
    if (form.id === "new_email_message")
      return;

    form.addEventListener("submit", () => {
      const submits = form.querySelectorAll('button[type="submit"], input[type="submit"]');

      submits.forEach(btn => {
        btn.disabled = true;
        btn.classList.add("opacity-50", "cursor-not-allowed");
      });
    });
  });

  document.querySelectorAll(".nested_documents").forEach(item => {
    item.querySelectorAll(".has-many-remove").forEach(removeBtn => {
      removeBtn.parentElement.style.display = "none";
    });
  });

  const menu = document.getElementById("main-menu");
  const toggle = document.querySelector('[data-drawer-target="main-menu"]');
  const isRTL = document.body.dir === "rtl";

  // Helper to check if menu is open
  const isOpen = () => menu.classList.contains("translate-x-0");

  // Toggle menu
  const toggleMenu = () => {
    if (isRTL) {
      menu.classList.toggle("translate-x-0");
      menu.classList.toggle("translate-x-full");
    } else {
      menu.classList.toggle("translate-x-0");
      menu.classList.toggle("-translate-x-full");
    }
  };

  // Close menu (Tailwind classes)
  const closeMenu = () => {
    if (isRTL) {
      menu.classList.remove("translate-x-0");
      menu.classList.add("translate-x-full");
    } else {
      menu.classList.remove("translate-x-0");
      menu.classList.add("-translate-x-full");
    }
  };

  // Toggle on button click
  toggle.addEventListener("click", (e) => {
    e.stopPropagation(); // prevent closing immediately
    toggleMenu();
  });

  // Close when clicking outside
  document.addEventListener("click", (e) => {
    if (!menu.contains(e.target) && !toggle.contains(e.target) && isOpen()) {
      closeMenu();
    }
  });

  document.querySelectorAll("[data-auto-open='true']").forEach((element) => {
    const modal = new Modal(element);
    modal.show();
  });
});
